import { useEffect, useState } from 'react'
import { Divider } from 'antd'
import { TransactionStateHistoryDto } from 'api/Transaction/Types/TransactionStateHistoryDto'
import { Box } from 'components/Box'
import { Label } from 'components/Input/styles'
import { Spinner } from 'components/Spinner'
import { formatLocalDateUTC } from 'utils/date'
import { isNotEmpty } from 'utils/is-empty'

import { useApiClient } from '../../../utils/api/ApiClient'
import { WalletsApiClient } from '../../../utils/api/walletsApiClient'

const Input = ({
  value,
  label,
  textarea = false,
}: {
  value: string
  label: string
  textarea?: boolean
}) => (
  <div style={{ width: '100%', display: 'flex' }}>
    <label style={{ fontWeight: 'bold', width: '25%' }}>{label}</label>
    {textarea ? (
      <textarea
        style={{
          color: '#0e76eb',
          border: 'none',
          transition: 'all 0.2s ease',
          backgroundColor: 'transparent',
          fontSize: 14,
          outline: 'none',
          textAlign: 'left',
          width: '100%',
          resize: 'none',
        }}
        disabled
        rows={4}
        value={value}
      />
    ) : (
      <input
        style={{
          color: '#0e76eb',
          border: 'none',
          transition: 'all 0.2s ease',
          backgroundColor: 'transparent',
          fontSize: 14,
          outline: 'none',
          textAlign: 'left',
          width: '100%',
        }}
        disabled
        type='text'
        value={value}
      />
    )}
  </div>
)
const HistoryListItem = ({
  date,
  status,
  reason,
  index,
  userReason,
  category,
}: {
  date: string // test
  status: string
  reason: string
  index: number | string
  userReason: string | null
  category?: string
}) => (
  <div key={index}>
    <Input label={'Date'} value={formatLocalDateUTC(date, true) || ''} />
    <Input label={'Status'} value={status} />
    {category && <Input label={'Category'} value={category} />}
    {!userReason && <Input label={'Reason'} value={reason} />}
    {userReason && (
      <Input textarea={userReason.length > 50} label={'User reason'} value={userReason} />
    )}
    <Divider />
  </div>
)
const TransactionHistoryDetails: React.FC<{ id: string }> = ({ id }) => {
  const walletsApiClient = useApiClient(WalletsApiClient)
  const [loading, setLoading] = useState<boolean>(false)
  const [transactionStatusHistory, setTransactionStatusHistory] =
    useState<null | TransactionStateHistoryDto>(null)
  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setLoading(true)
        const response = await walletsApiClient.getTransactionStatusHistory(id)
        setTransactionStatusHistory(response)
        setLoading(false)
      } catch (e) {
        console.error(e)
        setLoading(false)
      }
    }
    fetchHistory()
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return <Spinner />
  }

  return (
    <Box display='flex' flexDirection='column' style={{ width: '90%', margin: 32 }}>
      {transactionStatusHistory && isNotEmpty(transactionStatusHistory) ? (
        transactionStatusHistory.history.map((historyReason, i) => (
          <HistoryListItem
            status={historyReason.transactionState.name}
            date={historyReason.createdDate}
            index={i}
            reason={historyReason.transactionStateReason.name}
            userReason={historyReason.reason}
            category={historyReason.transactionStateCategory?.name}
          />
        ))
      ) : (
        <Label>No history...</Label>
      )}
    </Box>
  )
}

export default TransactionHistoryDetails
